// import React from "react";
// import Wrapper from "./shared/Wrapper";

// const handleClick = () => {};

// const KeyHandler = (e) => {};

// const CustomButton = (props) => {
//   const {
//     isLiveText,
//     defaultSelected,
//     fontSize,
//     width,
//     height,
//     top,
//     left,
//     right,
//     bottom,
//     position,
//     border,
//     opacity,
//     margingcustom,
//     display,
//     alignItems,
//     style,
//     type,

//     ...rest
//   } = props; // Destructure props to avoid passing invalid ones to the button
//   const styles = {
//     button: {
//       textAlign: isLiveText ? "left" : null,
//       border: border || "2px solid #393939",
//       // background: defaultSelected ? "#FF671F" : "#393939",
      
//       background: type === "referral-button"
//         ? "none"
//         : isLiveText ? 
//          "rgba(202, 202, 202, 1)"
//         : defaultSelected
//         ? "#EC008C"
//         : "#0E1653",
//       opacity: opacity || "",
//       borderRadius: "7.5px",
//       // padding: "10px 20px",
//       color: type === "referral-button" && defaultSelected? "#EC008C" :  isLiveText ? "#333" : "#FFFFFF",
//       fontSize: fontSize || "24px",
//       cursor: "pointer",
//       outline: "none",
//       transition: "background 0.3s, border 0.3s",
//       width: isLiveText ? "fit-content" : width || "auto",
//       height: height || "auto",
//       marginTop: top || "auto",
//       marginLeft: left || "auto",
//       marginRight: right || "auto",
//       marginBottom: bottom || "auto",
//       position: position || "absolute",
//       alignItems: alignItems,
//       display: display,
//     },
//   };
//   return (
//     <Wrapper
//       as="button"
//       style={{
//         ...styles.button,
//         ...style,
//       }}
//       onClick={props.onClick}
//       onKeyDown={props.onKeyDown}
//     >
//       {props.children}
//     </Wrapper>
//   );
// };
// export default CustomButton;


import React from "react";
import Wrapper from "./shared/Wrapper";

const CustomButton = (props) => {
  const {
    isLiveText,
    defaultSelected,
    fontSize,
    width,
    height,
    top,
    left,
    right,
    bottom,
    position,
    border,
    opacity,
    margincustom,
    display = "inline-flex",
    alignItems = "center",
    justifyContent = "center",
    style,
    type,
    onClick,
    onKeyDown,
    children,
    isCommingText,
    ...rest
  } = props;

  const styles = {
    button: {
      textAlign: isLiveText ? "left" : "center",
      border: border || "none",
      background: type === "referral-button"
        ? "none"
        : isLiveText 
        ? "rgb(255, 255, 255)"
        : defaultSelected
        ? "#EC008C"
        :isCommingText?"rgba(202, 202, 202, 1)"
        : "#0E1653",
      opacity: opacity || 1,
      borderRadius: "8px",
      color: type === "referral-button" && defaultSelected 
        ? "#EC008C" 
        : isLiveText 
        ? "#333" 
        : "#FFFFFF",
      fontSize: fontSize || "24px",
      fontFamily: "Anek Latin",
      cursor: "pointer",
      outline: "none",
      transition: "background 0.3s, border 0.3s",
      width: isLiveText ? "fit-content" : "fit-content" || "auto",
      height: height || "auto",
      marginTop: top,
      marginLeft: left,
      marginRight: right,
      marginBottom: bottom,
      position: position,
      display: display,
      alignItems: alignItems,
      justifyContent: justifyContent,
      padding: "10px 30px",
      whiteSpace: "nowrap",
      ...(position === "absolute" ? {} : { flexShrink: 0 }),
      ...style,
    },
  };

  return (


    <Wrapper
      as="button"
      style={styles.button}
      onClick={onClick}
      onKeyDown={onKeyDown}
      {...rest}
      type={type}
    >
      {children}
    </Wrapper>
  );
};

export default CustomButton;


// import React from "react";
// import Wrapper from "./shared/Wrapper";

// const handleClick = () => {};

// const KeyHandler = (e) => {};

// const CustomButton = (props) => {
//   const {
//     isLiveText,
//     defaultSelected,
//     fontSize,
//     width,
//     height,
//     top,

//     left,
//     right,
//     bottom,
//     position,
//     border,
//     opacity,
//     margingcustom,
//     display,
//     alignItems,
//     style,
//     type,
//     ...rest
//   } = props; // Destructure props to avoid passing invalid ones to the button
//   const styles = {
//     button: {
//       textAlign: isLiveText ? "left" : null,
//       border: border || "2px solid #393939",
//       // background: defaultSelected ? "#FF671F" : "#393939",
      
//       background: type === "referral-button"
//         ? "none"
//         : isLiveText ? 
//          "rgba(202, 202, 202, 1)"
//         : defaultSelected
//         ? "#EC008C"
//         : "#0E1653",
//       opacity: opacity || "",
//       borderRadius: "7.5px",
//       // padding: "10px 20px",
//       color: type === "referral-button" && defaultSelected? "#EC008C" :  isLiveText ? "#333" : "#FFFFFF",
//       fontSize: fontSize || "24px",
//       cursor: "pointer",
//       outline: "none",
//       transition: "background 0.3s, border 0.3s",
//       // width: isLiveText ? "fit-content" : width || "auto",
//       width: isLiveText ? "fit-content" : width !== null && width !== undefined ? width : "fit-content" || "auto",
//       height: height || "auto",
//       marginTop: top || "auto",
//       marginLeft: left || "auto",
//       marginRight: "0",
//       marginBottom: bottom || "auto",
//       position: "absolute",
//       // alignItems: alignItems,
//       display: "flex",
//       boxSizing: "border-box",
//       gap: "2rem",
//       padding: "1rem 1rem",
//       justifyContent:"center"
//       // left: "2rem" || "auto",
//     },
//   };
//   return (
//     <Wrapper
//       as="button"
//       style={{
//         ...styles.button,
//         ...style,
//       }}
//       onClick={props.onClick}
//       onKeyDown={props.onKeyDown}
//     >
//       {props.children}
//     </Wrapper>
//   );
// };
// export default CustomButton;

